import { Publisher } from '../model/publisher.class';
import { Model } from '../model/model.class';

export class User extends Model {

  public userId: number;

  constructor(
    public mail: string,
    public lastName: string,
    public firstName: string,
    public password: string,
    public userType: string,
    public lastAction: Date,
    public publisher: Publisher
  ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/user.class.ts